/**
 * Minimalerei FAQ — Phase 3.H
 *
 * <minimalerei-faq> Custom Element. The native <details>/<summary>
 * elements handle open/close themselves; this Custom Element only
 * exists to enforce single-open accordion behaviour when
 * data-accordion-mode === "single". Multi-mode is purely native, no
 * JS interaction needed.
 */
class MinimalereiFaq extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.mode = this.dataset.accordionMode || 'single';
    this.items = this.querySelectorAll('.mp-faq__item');
    if (this.mode !== 'single' || !this.items.length) return;

    this.boundToggle = this.handleToggle.bind(this);
    this.items.forEach((item) => item.addEventListener('toggle', this.boundToggle));
  }

  disconnectedCallback() {
    if (!this.boundToggle) return;
    this.items.forEach((item) => item.removeEventListener('toggle', this.boundToggle));
  }

  handleToggle(event) {
    if (!event.target.open) return;
    this.items.forEach((item) => {
      if (item !== event.target && item.open) {
        item.removeAttribute('open');
      }
    });
  }
}

if (!customElements.get('minimalerei-faq')) {
  customElements.define('minimalerei-faq', MinimalereiFaq);
}
